import { Corbado } from './core/Corbado';
const corbado = new Corbado();
export { CorbadoThemes } from '@corbado/react';
export default corbado;
